import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

function Support() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-link">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 3l-5 5 5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Back to Home
        </Link>
        
        <h1 className="legal-title">Support</h1>
        
        <div className="legal-content">
          <p>
            Need help? Have questions? We're here to assist you!
          </p>

          <section>
            <h2>Contact Us</h2>
            <p>
              For any inquiries, feedback, or support requests, please reach out to us at:
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:gevorg@joindiscoverly.com">gevorg@joindiscoverly.com</a>
            </p>
            <p>
              We typically respond within 24-48 hours during business days.
            </p>
          </section>

          <section>
            <h2>What We Can Help With</h2>
            <ul>
              <li>Account issues and technical support</li>
              <li>Questions about features and functionality</li>
              <li>Privacy and data concerns</li>
              <li>Feedback and suggestions</li>
              <li>Partnership inquiries</li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Support;

